import { createSelector } from '@reduxjs/toolkit';
import {
  ENVIRONMENT,
  selectAccountId,
  selectAccountName,
  selectApp,
  selectBroadcastHash,
  selectEnvironmentConfig,
  selectUserId,
  selectUserName,
} from '@socialive/common';

const isLocalhost = window.CONFIG?.environment === ENVIRONMENT.LOCAL;
const jira = window.location.hostname.match(/^\w{3,5}-\d+/)?.[0] ?? '';

export default createSelector(
  selectEnvironmentConfig,
  selectApp,
  selectBroadcastHash,
  selectAccountId,
  selectAccountName,
  selectUserId,
  selectUserName,
  ({ isProduction, environment }, app, broadcastHash, accountId, accountName, userId, userName) => ({
    environment,
    isLocalhost,
    jira,
    app,
    broadcastHash,
    accountId,
    accountName: isProduction ? '' : accountName,
    userId,
    userName: isProduction ? '' : userName,
  })
);
